import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReplaceSemicolonPipe } from 'src/app/pipes/replace-semicolon.pipe';
import { shortDescriptionPipe } from './short-description.pipe';


@NgModule({
    declarations: [
        ReplaceSemicolonPipe,
        shortDescriptionPipe
    ],
    imports: [ CommonModule ],
    exports: [
        ReplaceSemicolonPipe,
        shortDescriptionPipe
    ],
    providers: [],
})
export class PipeModule {}